import { createFileRoute } from '@tanstack/react-router';
import jwtDecode from 'jwt-decode';
import { type RmClaims } from 'src/api/queries/user';
import { EnterpriseSettingsPage } from 'src/apps/fleet/app/pages/Settings';
import { authHelpers } from 'src/utils/authHelpers';
import { AccessDeniedError } from 'src/utils/errors';
import { userHelpers } from 'src/utils/userHelpers';

export const Route = createFileRoute(
  '/_auth/enterprise/_with-org/_layout/settings'
)({
  async beforeLoad({ context }) {
    const auth = await context.auth;
    const accessToken = await authHelpers.getAccessTokenSilently(auth);
    const claims = jwtDecode<RmClaims>(accessToken);
    if (!userHelpers.hasPermissionReadOrganizationSettings(claims)) {
      throw new AccessDeniedError(
        'You do not have permission to view this page. Please contact your IT admin to request access.'
      );
    }
  },
  component: () => <EnterpriseSettingsPage />,
});
